/* AoV – köpbekräftelse för Standardprodukt */
(() => {
  if (window.aovStickyConfirmationInstalled) return;
  window.aovStickyConfirmationInstalled = true;

  let timer;

  document.addEventListener('ajaxProduct:added', () => {
    if (!document.querySelector('[data-aov-sticky-cart]')) return;

    const sticky = document.querySelector('product-sticky-form');
    const button = sticky?.querySelector('button[name="add"]');
    const buttonText = button?.querySelector('.btn-text');

    if (!button || !buttonText) return;

    // Spara knappens ursprungliga innehåll.
    if (!button.dataset.aovOriginalHtml) {
      button.dataset.aovOriginalHtml = buttonText.innerHTML;
    }

    clearTimeout(timer);

    button.classList.add('aov-added');
   buttonText.textContent = document.documentElement.lang
  .toLowerCase().startsWith('sv')
  ? '✓ Tillagd!'
  : '✓ Added!';

    timer = setTimeout(() => {
      buttonText.innerHTML = button.dataset.aovOriginalHtml;
      button.classList.remove('aov-added');
    }, 2000);
  });
})();